const translations = {
  "en": {
    "Discuss with Edggy": "Discuss with Edggy"
  },
  "zh-tw": {
    "Discuss with Edggy": "與 Edggy 一起討論"
  }
};

export default translations;
